<mat-form-field *ngIf="initialized" [formGroup]="control">
    <mat-select id="countryCode" [(ngModel)]="selectedCountry" [formControlName]="'countryCode'">
        <mat-option *ngFor="let ccode of countryCodes" [value]="ccode.phone_code ? ccode.phone_code+'' : '   '" id="{{ccode.country}}">
            {{ ccode.country }} - (+{{ ccode.phone_code }})
        </mat-option>
    </mat-select>
    <mat-hint>Select a Country Code.</mat-hint>
</mat-form-field>

<mat-form-field *ngIf="!initialized" [formGroup]="control">
    <mat-select></mat-select>
    <mat-hint>Select a Country Code.</mat-hint>
</mat-form-field>
